class TokenDto {
	transaction = '';
	token: string | boolean = '';
	validated = '';
	size = '';
	contactType = 'phonenumber';
}

export default TokenDto;
